import React, { Component } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Select from 'react-select';
import { reactLocalStorage } from 'reactjs-localstorage';
import withRouter from '../../../util/WithRouter';
import Constants from '../../../util/Constants';
import CustomDatePicker from '../DailySalesReport/DatePickr';

class IndividualSalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null, // Changed to single option
      dateCondition: '',
      dateFrom: '',
      dateTo: '',
      alert: false,
      filteredOptions: [], // Filtered options for the dropdown
    };
  }

  componentDidMount() {
    const options = reactLocalStorage.getObject(Constants.Model).user.options;
    const loggedInUser = reactLocalStorage.getObject(Constants.LoggedInUser);
    const loggedInUserId = loggedInUser.user_id;
    const loggedInUserRole = loggedInUser.role;

    // Filter options for active statuses
    const activeOptions = options.filter(
      (option) => option.status === Constants.Active || option.status === Constants.AlwaysActive
    );

    let filteredOptions;
    if (loggedInUserRole === "ADMIN") {
      // If the user is an admin, show all options
      filteredOptions = activeOptions;
    } else {
      // Otherwise, show the logged-in user and their reporting persons
      filteredOptions = activeOptions.filter(
        (option) => option.reporting === loggedInUserId || option.value === loggedInUserId
      );
    }

    // Find the logged-in user in the options
    const loggedInUserOption = activeOptions.find((option) => option.value === loggedInUserId);

    this.setState({
      selectedOption: loggedInUserOption || null,
      filteredOptions,
    });
  }

  handleSelectChange = (option) => {
    this.setState({ selectedOption: option });
  };

  handleMenuOpen = () => {
    const { selectedOption } = this.state;
    const options = reactLocalStorage.getObject(Constants.Model).user.options.filter(
      (option) => option.status === Constants.Active || option.status === Constants.AlwaysActive
    );
    const loggedInUser = reactLocalStorage.getObject(Constants.LoggedInUser);
    const loggedInUserRole = loggedInUser.role;

    let filteredOptions;
    if (loggedInUserRole === Constants.Admin) {
      // If the user is an admin, show all options
      filteredOptions = options;
    } else if (selectedOption) {
      // Show only the reporting persons for the selected user
      filteredOptions = options.filter((option) =>
        option.reporting === selectedOption.value
      );
    } else {
      // Default to the logged-in user's options if no other user is selected
      const loggedInUserId = loggedInUser.user_id;
      filteredOptions = options.filter(
        (option) => option.reporting === loggedInUserId || option.value === loggedInUserId
      );
    }

    this.setState({ filteredOptions });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { selectedOption, dateCondition, dateFrom, dateTo } = this.state;
    if (!dateFrom || !dateTo || !selectedOption) {
      this.setState({ alert: true });
      return;
    }

    const queryParams = {
      options: `~${selectedOption.value}~`,
      dateCondition,
      dateFrom,
      dateTo,
    };

    this.props.navigate(`/report/individualSalesReport/1?${new URLSearchParams(queryParams).toString()}`);
  };

  onValueChange = (field_key, condition, value, model_key) => {
    const [dateFrom, dateTo] = value.split('~');
    this.setState({ dateCondition: condition, dateFrom, dateTo });
  };

  render() {
    const { filteredOptions, alert, selectedOption } = this.state;

    return (
      <>
        {alert && (
          <Alert key="danger" variant="danger" dismissible className="m-2 p-3" onClose={() => this.setState({ alert: false })}>
            All fields are mandatory. Please fill them out.
          </Alert>
        )}
        <Form onSubmit={this.handleSubmit} className="m-3 p-3 shadow-sm" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
          <Row className="align-items-center">
            {/* Custom Date Picker */}
            <Col sm={6}>
              <CustomDatePicker onDateChange={(dateFrom, dateTo) => this.onValueChange('enquiry_date', 'BETWEEN', `${dateFrom}~${dateTo}`)} type={'individual report'} label={true} />
            </Col>

            {/* Single-select dropdown */}
            <Col sm={6}>
              <Form.Group controlId="formSelect">
                <Form.Label style={{ fontWeight: 'bold' }}>User</Form.Label>
                <Select
                  options={filteredOptions}
                  value={selectedOption}
                  onChange={this.handleSelectChange}
                  onMenuOpen={this.handleMenuOpen}
                  placeholder="Select User"
                  required
                />
              </Form.Group>
            </Col>

            {/* Submit button */}
            <Col sm={12} className="d-flex justify-content-center mt-3">
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </>
    );
  }
}

export default withRouter(IndividualSalesReport);
